import type { PassThrough } from '@primevue/core';
import type { DrawerPassThroughOptions } from 'primevue/drawer';
import type { PassThroughOptionType } from '../utils';

/** Edge the drawer slides in from. */
export enum DrawerPosition {
  LEFT = 'left',
  RIGHT = 'right',
}

/**
 * `root` / `mask` / `transition` reach PrimeVue's Drawer. The other sections are bound onto the
 * Meridia chrome rendered inside its `#container` slot: `class` merges, any other attribute
 * (e.g. `data-testid`) is added.
 */
export type MeridiaDrawerPassThrough = PassThrough<
  Pick<DrawerPassThroughOptions, 'root' | 'mask' | 'transition'>
> & {
  header?: PassThroughOptionType;
  title?: PassThroughOptionType;
  subtitle?: PassThroughOptionType;
  closeButton?: PassThroughOptionType;
  body?: PassThroughOptionType;
  footer?: PassThroughOptionType;
};
